<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
    <div class="container tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
      <h2 class="tw-mb-12 lg:tw-mb-14"> {{ vars.titleText }}</h2>
      <div class="tw-flex tw-w-full tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-gap-10 xl:tw-gap-12">
        <div
          v-for="card in cards"
          class="tw-flex tw-flex-1 tw-text-center tw-items-center tw-flex-col tw-gap-6 tw-p-7"
          
        >
          <div class="tw-h-28 tw-w-28">
            <library-image :src="card.icon" :alt="card.title" image-class="tw-h-full tw-w-full" />
          </div>
          <h3>{{ card.title }}</h3>
          <p>{{ card.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8OurValues',

  mixins: [ComponentMixin],

  data() {
    return {};
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
